import LHead from '@/layouts/components/head.vue';
import LFooter from '@/layouts/components/footer.vue';
export default {
  name: 'Layouts',
  components: {
    LHead,
    LFooter
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};